export const getFileName = (src: string): string => {
  const lastSlash = src.lastIndexOf("/");
  const filenameWithExtension = lastSlash !== -1 ? src.slice(lastSlash + 1) : src;
  const lastDot = filenameWithExtension.lastIndexOf(".");

  const baseName = lastDot === -1 ? filenameWithExtension : filenameWithExtension.slice(0, lastDot);
  return baseName ? baseName : src;
};
